import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as organization from '../../organization'

export const RESOURCE = {
  payload: {
    description:
      'A sub-unit of an academic or administrative unit within an institution.',
    dimension: organization.RESOURCE.payload,
    level: 3,
    name: 'Subdepartment',
    partialId: PartialId.Standard.create('subdept'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
